import { BASE_API_URL } from 'Constants'
import AxiosClient from './api'

import ENDPOINT from './constants'
import { getBase64V2 } from 'Utils/image'

const useLocalStorage = import.meta.env.VITE_USE_LOCAL_STORAGE === 'true'

function checkExistFile({ folderId = 0, params }) {
  if (useLocalStorage) {
    return Promise.resolve({ success: true, result: [] })
  }
  return AxiosClient.get(ENDPOINT.UPLOAD_FILE.CHECK_EXIST_FILE, folderId, { params })
    .then(({ data }) => data)
}

async function getS3PresinedUrl({ fileList }) {
  if (useLocalStorage) {
    return { data: [] }
  }
  return AxiosClient.post(`${BASE_API_URL}${ENDPOINT.PRESIGNED}`, fileList)
    .then(({ data }) => data)
}

async function uploadImageNote(formData) {
  if (useLocalStorage) {
    const file = formData.get('image')
    const dataUrl = file ? await getBase64V2(file) : 'data:image/png;base64,'
    return { success: true, result: dataUrl }
  }
  return AxiosClient.put(`${ENDPOINT.NOTE_UPLOAD_IMAGE}`, formData)
    .then(({ data }) => data)
}

export {
  checkExistFile,
  getS3PresinedUrl,
  uploadImageNote
}
